import React from "react";
import TaskResponseSummary from "./TaskResponseSummary";

export default function TaskTextCompleted(props) {
  return <TaskResponseSummary {...props} />;
}
